import { call, put, takeLatest } from "redux-saga/effects";
import { uploadFiles } from "./fileUploadApi";
import { uploadStart, uploadSuccess, uploadFailure } from "./fileUploadSlice";
import { showToast } from "../../../components";

// Remove this constant since we'll use the action type from slice
// export const UPLOAD_FILES_REQUEST = "fileUpload/uploadFilesRequest";

function* uploadFilesSaga(action) {
  try {
    const { onSuccess } = action.payload;
    const result = yield call(uploadFiles, action.payload);

    if (result?.success) {
      console.log("result", result);
      onSuccess(result.data.data || result.data);
      yield put(uploadSuccess());
    } else {
      showToast(result?.error || "Upload failed","error",3000);
      yield put(uploadFailure("Upload failed"));
    }
  } catch (error) {
    showToast(result?.error || "Failed to upload file! Please contact support.","error",3000);
    console.log('file upload saga error ::: ', error);
    yield put(uploadFailure(error.message));
  }
}

export function* watchFileUpload() {
  yield takeLatest(uploadStart.type, uploadFilesSaga);
}
